import React from 'react';

import SpBasicTemplate from 'components/templates/SpBasicTemplate';
import SpFinishContact from 'components/molecules/SpFinishContact';

import { THANKS_TEXT } from 'utils/constant';

const PresentSP = ({
  onClickMainButton,
}) => (
  <div className="Thanks">
    <SpBasicTemplate 
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
      valid={true}
    >
    <span>
      <SpFinishContact
        info={THANKS_TEXT.information}
      />
    </span>
    </SpBasicTemplate>
  </div>
);  

export default PresentSP;